import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { windowLabel } from "@/lib/api";
import { toast } from "sonner";
import { Star } from "lucide-react";
import SeoCopy from "@/components/SeoCopy";

export default function ReviewsPage() {
  const [reviews, setReviews] = useState([]);
  useEffect(() => { api.get("/reviews").then((r) => setReviews(r.data)); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-fredoka text-3xl sm:text-4xl font-bold text-slate-900 mb-2" data-testid="reviews-title">Community Reviews ⭐</h1>
      <p className="text-slate-600 mb-4">What real customers say about Bag Dash Kids.</p>

      {reviews.length === 0 ? (
        <div className="card-clay p-8 text-center text-slate-400">No reviews yet. Be the first!</div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-3" data-testid="reviews-list">
          {reviews.map((r, i) => (
            <div key={i} className="card-clay p-5" data-testid={`review-${i}`}>
              <div className="flex items-center gap-1">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star key={idx} size={16} className={idx < r.rating ? "fill-amber-400 text-amber-400" : "text-slate-200"}/>
                ))}
              </div>
              <p className="text-sm text-slate-700 mt-2">"{r.comment || "Great service!"}"</p>
              <div className="text-xs text-slate-500 mt-2 font-semibold">— {r.user_name} · {r.community}</div>
            </div>
          ))}
        </div>
      )}

      <div className="mt-6">
        <Link to="/reviews/new" className="btn-push-amber inline-block px-5 py-2.5" data-testid="leave-review-cta">Leave a review (+50 pts)</Link>
      </div>
      <SeoCopy
        title="Real Bag Dash Kids reviews"
        links={[
          { to: "/about", label: "Meet the Kids" },
          { to: "/schedule", label: "Schedule a pickup" },
          { to: "/quick-pay", label: "Quick Pay" },
          { to: "/contact", label: "Contact support" },
        ]}
      >
        <p>Reviews come from <strong>verified Bag Dash Kids customers</strong> across our served communities. Each review you leave earns <strong>+50 Dash Rewards points</strong> and helps Big Sib Josiah and Lil Sib Jayla grow as young entrepreneurs. We don&apos;t filter critical reviews — Mom Manager Donja reads every one and uses them to coach the kids.</p>
        <p>Want to share your experience? Tap <strong>Leave a review</strong> above. Honest feedback &mdash; positive or constructive &mdash; helps your neighbors decide and helps the kids get better at what they do.</p>
      </SeoCopy>
    </div>
  );
}
